import { useAppSelector } from "redux/hooks";

const usePass = (): boolean => {
  const { userOtp } = useAppSelector((state) => state.otp);
  const isNextScreensS = userOtp?.NextScreens?.includes("N") as boolean;
  const isPass: boolean = isNextScreensS;

  return isPass;
};

export default usePass;
